module.exports = __webpack_public_path__ + "static/media/yelpCamp.6367efe0.gif";